import setLoggedInProfile from './set-logged-in-profile';
import setLoggedInStatus from './set-logged-in-status';
import setCheckinMode from './set-checkin-mode';
import setCompany from './set-company';
import setPusher from './set-pusher';

export default {
    setCompany,
    setCheckinMode,
    setLoggedInProfile,
    setLoggedInStatus,
    setPusher,
}


// WEBPACK FOOTER //
// ./src/app/store/users/mutations/index.js